/**
 * What a list failing mid-day does — stop that group for the day, or let
 * the day finish.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';

import { ChoiceChips } from '../controls/ChoiceChips';

const OPTIONS = [
  { value: 'STOP_FOR_DAY', label: 'Stop list' },
  { value: 'FINISH_DAY', label: 'Complete list' },
] as const;
type FailMode = (typeof OPTIONS)[number]['value'];

interface Props {
  value: string;
  onChange: (value: string) => void;
  compact?: boolean;
}

export const FailModeChoice: FC<Props> = ({ value, onChange, compact = false }) => (
  <div className={compact ? 'flex items-center [&_[role=radio]]:h-6 [&_[role=radio]]:gap-1.5 [&_[role=radio]]:px-2 [&_[role=radio]]:text-[11px]' : 'flex flex-wrap items-center gap-x-3 gap-y-2'}>
    <ChoiceChips options={OPTIONS} value={value as FailMode} onChange={onChange} ariaLabel="If a list fails mid-day" />
    {compact ? null : <span className="text-xs text-muted-foreground">{value === 'STOP_FOR_DAY' ? 'the rest of today is skipped' : 'today still finishes'}</span>}
  </div>
);
